import React from 'react';
export const BRAND_LOGO_URL = 'https://cdn.magicpatterns.com/uploads/8aow3XkdDkYvw53LvDLCGb/logo.svg';
type BrandLogoProps = {
  className?: string;
};
export function BrandLogo({
  className = 'h-11 w-auto'
}: BrandLogoProps) {
  return <img src={BRAND_LOGO_URL} alt="Grupo Consultor Colombiano" className={className} data-id="element-41" data-mp="1puiefr5vnw8l" />;
}